document.addEventListener('DOMContentLoaded', function () {
  let websocket = null;
  const emailSpan = document.getElementById('owner_username'); 	
  
  function addNewMessage(packet) {
    const msgElem = generateMessage(packet);
    document.getElementById('messages').insertAdjacentHTML('beforeend', msgElem);
    scrollToLastMessage();
  }

  function addNewUser(packet) {
    const userList = document.getElementById('user-list');
    userList.innerHTML = '';
    packet.value.forEach(function (userInfo) {
      if (userInfo.email === getUsername()) return;
      const templateSource = document.getElementById('user-list-item-template').innerHTML;
      const tmpl = Handlebars.compile(templateSource);
      userList.insertAdjacentHTML('beforeend', tmpl(userInfo));
    });
  }

  function scrollToLastMessage() {
    const msgs = document.getElementById('messages');
    msgs.scrollTop = msgs ? msgs.scrollHeight : 0;
  }

  function generateMessage(context) {
    const templateSource = document.getElementById('chat-message-template').innerHTML;
    const tmpl = Handlebars.compile(templateSource);
    return tmpl({ msg: context });
  }

  function getUsername() {  
    return emailSpan ? emailSpan.value.trim() : null;
  }

  function setupChatWebSocket() {
    //websocket = new WebSocket(document.getElementById('ws-server-path').value + getUsername());

	const wsPathElem = document.getElementById('chat-server-name');
	const username = getUsername();

	if (wsPathElem && wsPathElem.value && username) {
	  websocket = new WebSocket(wsPathElem.value + username);
	} else {
	  console.error('Cannot create WebSocket. Missing ws-server-path element, value, or username.', wsPathElem, wsPathElem.value,  username);
	  return ;
	}


    websocket.onopen = function () {
      const onConnectPacket = JSON.stringify({
        type: "new-user",
        email: getUsername()
      });
      console.log('connected, sending:', onConnectPacket);
      websocket.send(onConnectPacket);
    };

    websocket.onclose = function () {
      console.log('disconnected');
      const onClosePacket = JSON.stringify({ type: 'close' });
      websocket.send(onClosePacket);
    };

    websocket.onmessage = function (event) {
      let packet;
      try {
        packet = JSON.parse(event.data);
        console.log(packet);
      } catch (e) {
        console.error(e);
      }

      switch (packet.type) {
        case "users-changed":
          addNewUser(packet);
          break;
        case "new-message":
          addNewMessage(packet);
          break;
        case "typing":
          console.log('someone is typing...');
          break;
        default:
          console.log('error: ', event);
      }
    };
  }

  function broadCastMessage(message) {
    const newMessagePacket = JSON.stringify({
      type: 'new-message',
      email: getUsername(),
      message: message
    });
    websocket.send(newMessagePacket);
  }

  // Event listeners
const chatMessageInput = document.getElementById('chat-message');

if (chatMessageInput) {
  chatMessageInput.addEventListener('keypress', function (e) {
    if (e.key === 'Enter' && this.value && this.value.trim()) {
      broadCastMessage(this.value.trim());
      this.value = '';
      e.preventDefault();
    }
  });
} else {
  console.warn('Element with id "chat-message" not found.');
}


const sendBtn = document.getElementById('btn-send-message');

if (sendBtn) {
  sendBtn.addEventListener('click', function () {
    try {
      const msg = chatMessageInput.value.trim();
      if (!msg) return; // Don't send empty messages

      if (typeof broadCastMessage === 'function') {
        broadCastMessage(msg);
        chatMessageInput.value = '';
      } else {
        console.error('broadCastMessage function is not defined');
      }
    } catch (error) {
      console.error('Error sending message:', error);
    }
  });
} else {
  console.warn('Send message button not found');
}
  const floatingChat = document.querySelector('.floating-chat');
  if (floatingChat ) {
    floatingChat.addEventListener('click', function () {
	    console.log('floating-chat clicked!!!');	
	  if (websocket == null ){
		  console.log('setting up websocket!!!');	
		  setupChatWebSocket();
		  scrollToLastMessage();
	  }
    });
  }
  
});
